import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '../../../styles/customCarousel.css';
import { FC } from 'react';
import { Carousel } from 'react-responsive-carousel';
import styled from 'styled-components';

interface IProps {
  files?: {
    fileLocation: string;
  }[];
}

const Image = styled.img`
  max-width: 500px;
  max-height: 500px;
`;

interface IIndicatorProps {
  isSelected: boolean;
}

const Indicator = styled.li<IIndicatorProps>`
  ${({ isSelected }) =>
    isSelected ? 'background: #bb0665' : 'border: 1px solid #000000'};
  border-radius: 50%;
  width: 8px;
  height: 8px;
  cursor: pointer;
  display: inline-block;
  margin: 0 8px;
`;

const ImageCarousel: FC<IProps> = ({ files }) => {
  return (
    <Carousel
      showArrows
      showThumbs={false}
      showStatus={false}
      renderIndicator={(clickHandler, isSelected, index, label) => (
        <Indicator onClick={clickHandler} isSelected={isSelected} />
      )}
    >
      {files?.map(({ fileLocation }, index) => (
        <div key={`file-${index}`} className="border">
          <Image src={fileLocation} />
        </div>
      ))}
    </Carousel>
  );
};

export default ImageCarousel;
